import { array, Decoder, number, object, string } from '@mojotech/json-type-validation'

import { judgeCaseDecoder } from './judgeCaseDecoder'
import { judgeRecordDecoder } from './judgeRecordDecoder'

import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'

export const judgeDetailDecoder: Decoder<JudgeDetail> = object({
  judgeId: number(),
  userOutput: string(),
  compileError: string(),
  runtimeError: string(),
  caseVerdicts: array(judgeCaseDecoder),
  submissionRecord: judgeRecordDecoder
})
